import styles from "./ThreeDotsLoader.module.scss";

type ThreeDotsLoaderProps = {
  className?: string;
};

const ThreeDotsLoader = ({ className }: ThreeDotsLoaderProps) => {
  return (
    <div className={`${styles.loader} ${className || ""}`} role="status" aria-label="Loading">
      <span className={styles.dot} />
      <span className={styles.dot} />
      <span className={styles.dot} />
    </div>
  );
};

export default ThreeDotsLoader;
